import { getTrackedAttributesString } from './trackingAttributesGenerator';

const FinaneFormTrackingId = ['FINANCE', 'PREQUAL'];

const formTrackingAttributesInjector = ({
	isDomainSSLEnabled,
	isSecureLoginEnabled
}) => {
	window.DDC.dataLayer.events.listener.listen(
		'ddc.form.submission',
		({ element }) => {
			if (element && element.closest('form')) {
				const { formTrackingId } = element.closest('form').dataset;
				// Apply for unsecured financing form only
				if (
					FinaneFormTrackingId.includes(formTrackingId) &&
					(!isDomainSSLEnabled || !isSecureLoginEnabled)
				) {
					const trackedData = getTrackedAttributesString();
					const financeForm = $(element.closest('form'));
					const trackedDataFormField = financeForm.find(
						'input[name="userSessionData"]'
					);
					if (trackedDataFormField.length) {
						trackedDataFormField.attr('value', trackedData);
					} else {
						financeForm.append(
							`<input type='hidden' name='userSessionData' class='hidden' data-id value=${trackedData}>`
						);
					}
				}
			}
		}
	);
};

export default formTrackingAttributesInjector;
